import { store } from "../store/store"
import {collection, getFirestore, onSnapshot} from 'firebase/firestore'
import { app } from "../../utils/Firebase"
import { setAnnoncesList } from "../reducers/annonces"

const dispatch = store.dispatch

const annonces = {
    registerAnnonce(data){
        return new Promise((resolve,reject)=>{
            
        })
    },
    getAnnoncesList(){
        return new Promise((resolve,reject)=>{
            onSnapshot(collection(getFirestore(app),'annonces'),snapShot => {
                let annoces = snapShot.docs.map(snap => {
                    return {id:snap.id , ...snap.data()}
                })
                dispatch(setAnnoncesList(annoces))
                resolve(annoces)
            },error =>{
                reject(error)
            })
        })
    },
}
export default annonces